<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 px-0">
      <yv-form-search
        :formSearch="formSearch"
        :inlineSearchAction="true"
        :enableExport="false"
        @search="search"
        ref="formSearch"
      ></yv-form-search>
    </div>
    <div class="md-layout-item md-size-100 px-0">
      <md-card>
        <md-card-content>
          <p class="font-medium">
            {{ $t("task_management.report_status_chart") }}
          </p>
          <div v-if="hiddenReportStatus">
            <no-data-found></no-data-found>
          </div>
          <div class="md-layout" v-else>
            <p class="md-layout-item md-size-100 font-medium text-sm px-0">
              {{ reportStatus.details | totalTask }}
              {{ $t("task_management.tasks") }}
            </p>
            <div class="md-layout-item md-size-50">
              <report-chart
                v-if="reportStatus.chart"
                :data="reportStatus.chart"
                type="status"
              ></report-chart>
            </div>
            <div class="md-layout-item md-size-50">
              <table class="table-task-management-report w-full text-center">
                <tr class="bg-[#E39157] text-white font-bold">
                  <td>{{ $t("common.status") }}</td>
                  <td>{{ $t("task_management.percentage") }}</td>
                  <td>{{ $t("task_management.number_of_tasks") }}</td>
                </tr>
                <tr
                  v-for="row in reportStatus.details"
                  :key="'status detail' + row.status"
                  class="text-[#333] font-medium text-xs"
                >
                  <td>{{ capitalizeFirstLetter(row.status) }}</td>
                  <td>{{ row.percentage }} %</td>
                  <td>{{ row.number_of_tasks }}</td>
                </tr>
              </table>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout-item md-size-100 px-0">
      <md-card>
        <md-card-content>
          <p class="font-medium">
            {{ $t("task_management.report_represents_current_progress") }}
          </p>
          <div v-if="hiddenReportTimeliness">
            <no-data-found></no-data-found>
          </div>
          <div class="md-layout" v-else>
            <p class="md-layout-item md-size-100 font-medium text-sm px-0">
              {{ reportTimeliness.details | totalTask }}
              {{ $t("task_management.tasks") }}
            </p>
            <div class="md-layout-item md-size-50">
              <report-chart
                v-if="reportTimeliness.chart"
                :data="reportTimeliness.chart"
                type="timeline"
              ></report-chart>
            </div>
            <div class="md-layout-item md-size-50">
              <table class="table-task-management-report w-full text-center">
                <tr class="bg-[#E39157] text-white font-bold">
                  <td>{{ $t("task_management.timeliness") }}</td>
                  <td>{{ $t("task_management.percentage") }}</td>
                  <td>{{ $t("task_management.number_of_tasks") }}</td>
                </tr>
                <tr
                  v-for="row in reportTimeliness.details"
                  :key="'timeliness detail' + row.timeliness"
                  class="text-[#333] font-medium text-xs"
                >
                  <td>{{ capitalizeFirstLetter(row.timeliness) }}</td>
                  <td>{{ row.percentage }} %</td>
                  <td>{{ row.number_of_tasks }}</td>
                </tr>
              </table>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import YvFormSearch from "@/components/Base/YvFormSearch";
import ReportChart from "./Chart";
import { service_paths } from "@/constants/Services";
import { capitalizeFirstLetter, getId, Message } from "@/helpers/utils";
import { mapGetters } from "vuex";
import { hasValidRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";

export default {
  components: { ReportChart, YvFormSearch },
  data() {
    return {
      capitalizeFirstLetter,
      formSearch: [
        {
          label: "task_management.filter_by_deadline_task",
          name: "deadline",
          value: [],
          type: "date-range",
          width: 25
        }
      ],
      reportStatus: {},
      reportTimeliness: {},
      hiddenReportStatus: true,
      hiddenReportTimeliness: true
    };
  },
  computed: {
    ...mapGetters("user", ["info", "role"])
  },
  filters: {
    totalTask(data) {
      const tasks = data?.map(el => el.number_of_tasks);
      return tasks.reduce((previous, current) => previous + current, 0);
    }
  },
  created() {
    this.getStaff();
    if (hasValidRole(this.role, [Role.Teacher, Role.Counselor])) {
      this.formSearch.push({
        label: "task_management.filter_by_action",
        name: "action",
        value: "reported",
        options: [
          {
            id: "reported",
            name: "task_management.assigned_to_me"
          },
          {
            id: "reviewed",
            name: "task_management.reviewed_by_me"
          }
        ],
        type: "select",
        width: 25
      });
    } else {
      this.formSearch.push(
        {
          label: "task_management.filter_by_user",
          name: "user_id",
          value: "",
          displayValue: "",
          options: [],
          type: "autocomplete",
          fields: {
            text: "name",
            value: "id"
          },
          searchKey: "full_name_or_staff_code",
          refetchOptions: this.getStaff,
          width: 25
        },
        {
          label: "task_management.filter_by_action",
          name: "action",
          value: "reported",
          options: [
            {
              id: "created",
              name: "task_management.created_by_user"
            },
            {
              id: "reported",
              name: "task_management.assigned_to_user"
            },
            {
              id: "reviewed",
              name: "task_management.reviewed_by_user"
            }
          ],
          type: "select",
          width: 25
        }
      );
    }
  },
  methods: {
    getStaff(param) {
      return this.$axios
        .get(
          `${service_paths.staffs}`,
          param,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(res => {
          let filterByUser = this.formSearch.find(
            item => item.name === "user_id"
          );
          filterByUser.options = res.data.data.map(item => ({
            id: getId(item),
            name: item
              ? `${item.full_name || ""} - ${item.staff_code || ""}`
              : ""
          }));
        });
    },
    search(queryParams) {
      const start_date = queryParams.deadline[0];
      const end_date = queryParams.deadline[1];
      if (!start_date || !end_date) {
        Message.error(this.$t("task_management.date_require"));
        return;
      }
      const { user_id, action } = queryParams;
      const params = { start_date, end_date, user_id, action };
      if (hasValidRole(this.role, Role.Teacher)) {
        params.user_id = getId(this.info);
      }
      this.getReportStatus(params);
      this.getReportTimeliness(params);
    },
    getReportStatus(params) {
      this.$axios
        .get(`${service_paths.reports}/task-managements/status`, params)
        .then(response => {
          this.hiddenReportStatus = response.data.data.every(el => el === 0);
          this.reportStatus = this.generateReport(response.data);
        });
    },
    getReportTimeliness(params) {
      this.$axios
        .get(`${service_paths.reports}/task-managements/timeliness`, params)
        .then(response => {
          this.hiddenReportTimeliness = response.data.data.every(
            el => el === 0
          );
          this.reportTimeliness = this.generateReport(response.data);
        });
    },
    generateReport(data) {
      return {
        chart: {
          data: data.data,
          labels: data.labels.map(label => capitalizeFirstLetter(label))
        },
        details: data.details
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.table-task-management-report {
  td {
    border: 1px solid #b4c3c3 !important;
    padding: 8px;
  }
}
</style>
